'use strict';

module.exports = require('virtual-dom/virtual-hyperscript/svg');



//////////////////
// WEBPACK FOOTER
// ./~/mercury/svg.js
// module id = 50
// module chunks = 0